import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'hydro/taskListTodo';

const taskListTodoService = {
  getTaskList: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default taskListTodoService;
